import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ADMIN_MENU } from '../constants/admin-menu';
import { PermissionService } from '../services/permission.service';

/**
 * Chặn trang quản trị nếu tài khoản không có quyền xem chức năng (route data: functionCode).
 * Không có quyền thì chuyển sang trang đầu tiên được phép, hoặc trang "không có quyền".
 */
export const permissionGuard: CanActivateFn = (route) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const functionCode: string | undefined = route.data['functionCode'];

  return permissionService.load().pipe(
    map(() => {
      if (!functionCode || permissionService.can(functionCode, 'read')) return true;

      const firstAllowed = ADMIN_MENU.find((item) => permissionService.can(item.code, 'read'));
      return router.createUrlTree([firstAllowed ? firstAllowed.route : '/admin/no-access']);
    }),
    catchError(() => of(router.createUrlTree(['/login']))),
  );
};
